import React from 'react';
import { Link } from 'react-router-dom';
import techsicoHeaderLogo from '../images/techsico_header_logo_375.svg';

const Header = () => (
  <div className="flex flex-row items-center p-5 px-9 h-20 md:px-16 lg:px-24 lg:h-24 2xl:px-34.5 2xl:h-31.5 3xl:px-48 3xl:h-40 bg-gray-500 text-white">
    <div>
      <Link to="/" className="text-left">
        <img
          className="mt-2 w-22.5 h-5 lg:mt-3 lg:w-24 lg:h-6 2xl:w-28 3xl:h-8 3xl:w-36"
          src={techsicoHeaderLogo}
          alt="Techsico Logo"
        />
        <h1 className="font-montserrat font-bold text-3xl leading-10 lg:text-4xl 2xl:text-6xl 3xl:text-7xl">
          Enterprise
        </h1>
      </Link>
    </div>
  </div>
);

export default Header;
